import { isTelegramMiniApp, isTelegramAdmin } from "./telegram-utils.js";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let gaInitialized = false;


export function initGA() {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    if (params.get('exclude_me') === 'true') {
      localStorage.setItem('ga_excluded', 'true');
    }
  }

  if (gaInitialized || typeof window === 'undefined' || isExcludedUser()) return;
  gaInitialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  // send_page_view: false because we fire page_view manually below,
  // once per route change (SPA navigation doesn't trigger gtag's auto page_view)
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  // Tags every subsequent event in this session with the platform
  gtag('set', 'user_properties', { app_platform: isTelegramMiniApp() ? 'telegram' : 'web' });
}

export function trackPageView(path) {
  if (typeof window.gtag !== 'function' || isExcludedUser()) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    app_platform: isTelegramMiniApp() ? 'telegram' : 'web',
  });
}

export function isExcludedUser() {
  if (isTelegramAdmin()) return true;
  if (localStorage.getItem('ga_excluded') === 'true') return true;
  return false;
}